import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';
import { EffectsModule } from '@ngrx/effects';

import * as fromCustomTags from './+state/custom-tags.reducer';
import { CustomTagsFacade } from './+state/custom-tags.facade';
import { CustomTagsEffects } from './+state/custom-tags.effects';

@NgModule({
    imports: [
        CommonModule,
        ToastrModule,
        StoreModule.forFeature(fromCustomTags.customTagsFeature),
        EffectsModule.forFeature([CustomTagsEffects]),
    ],
    providers: [CustomTagsFacade],
})
export class SharedStoresCustomTagsModule {}
